<template>
  <v-card class="mb-4">
    <v-card-subtitle class="py-0 d-flex justify-space-between align-center">
      <template v-if="link.type_space">
        <div class="text-overline">
          Space #{{ link.space.id }}
        </div>
        <template v-if="link.space?.is_active">
          <v-chip v-if="link.is_active"
                  color="success"
                  label
                  small
                  class="text-uppercase">
            Active
          </v-chip>
          <v-chip v-else-if="link.is_canceled"
                  color="warning"
                  label
                  small
                  class="text-uppercase">
            Canceled
          </v-chip>
          <v-chip v-else-if="link.is_expired"
                  color="warning"
                  label
                  small
                  class="text-uppercase">
            Expired {{ link.expired_at | datetime('YYYY-MM-DD') }}
          </v-chip>
        </template>
        <v-chip v-else
                color="warning"
                label
                small
                class="text-uppercase">
          Space Inactive
        </v-chip>
      </template>
      <template v-else-if="link.presentation">
        <div class="text-overline">
          Presentation #{{ link.presentation.id }}
        </div>
        <v-chip v-if="link.presentation.is_expired"
                color="warning"
                label
                small
                class="text-uppercase">
          Presentation Expired
        </v-chip>
        <v-chip v-else-if="link.presentation.is_inactive"
                color="warning"
                label
                small
                class="text-uppercase">
          Presentation Expired
        </v-chip>
        <v-chip v-else-if="link.is_canceled"
                color="warning"
                label
                small
                class="text-uppercase">
          Link Canceled
        </v-chip>
        <v-chip v-else-if="link.is_expired"
                color="warning"
                label
                small
                class="text-uppercase">
          Link Expired
        </v-chip>
        <v-chip v-else
                color="success"
                label
                small
                class="text-uppercase">
          Active
        </v-chip>
      </template>
    </v-card-subtitle>
    <v-card-title class="pt-0 pb-0">
      <router-link v-if="link.type_space"
                   :to="{name: 'admin.space.edit', params:{spaceID: link.space_id}}">
        {{ link.space.name }}
      </router-link>
      <a v-else-if="presentation"
         :href="`/admin/presentations/${link.presentation_id}`">
        {{ presentation.name }}
      </a>
    </v-card-title>
    <v-card-text class="pb-0">
      <div class="mb-4 d-flex">
        <div class="mr-4">
          Type: {{ link.type }}
        </div>
        <div class="mr-4">
          Owner: {{ link.user.name }}
        </div>
        <div class="mr-4">
          Created: {{ link.created_at | datetime('YYYY-MM-DD') }}
        </div>
        <div v-if="link.expires_at">
          Expires: {{ link.expires_at | datetime('YYYY-MM-DD') }}
        </div>
      </div>

      <SharedLinkField v-if="link.alias_url"
                       :link="link"
                       label="Friendly URL"
                       :url="addParameters(link.alias_url)"
                       hint="This is the friendly URL">
      </SharedLinkField>

      <SharedLinkField v-else
                       :link="link"
                       label="Link URL"
                       :url="addParameters(url)"
                       hint="This is the original URL that will not change.">
      </SharedLinkField>

      <p :class="showMore ? 'mb-4' : 'mb-0'"
         style="margin-top: -16px;">
        <a @click.prevent="showMore = !showMore">
          {{ showMore ? 'Show less' : 'Show more' }}
        </a>
      </p>

      <template v-if="showMore">

        <SharedLinkField v-if="link.alias_url"
                         :link="link"
                         label="Link URL"
                         :url="addParameters(url)"
                         hint="This is the original URL that will not change.">
        </SharedLinkField>


        <SharedLinkField v-if="link.prompt_url"
                         :link="link"
                         label="Prompt URL"
                         :url="addParameters(link.prompt_url)"
                         hint="Use this if you want to prompt the recipient to provide their email address.">
        </SharedLinkField>

        <SharedLinkField v-if="link.presentation_id && link.direct_url"
                         :link="link"
                         label="Direct URL"
                         :url="addParameters(link.direct_url)"
                         hint="Use this if you want to let the recipient view the file directly outside of the viewer.">
        </SharedLinkField>

        <SharedLinkField v-if="link.download_url"
                         :link="link"
                         label="Download URL"
                         :url="addParameters(link.download_url)"
                         hint="Use this if you want to let the recipient download the file.">
        </SharedLinkField>

        <SharedLinkField v-if="1===2 && link.embed_url"
                         :link="link"
                         label="Embed Code"
                         :url="link.embed_url"
                         embed
                         hint="Use this HTML code if you want to embed this file in a webpage.">
        </SharedLinkField>

      </template>

    </v-card-text>
    <v-card-actions>
      <v-btn :to="{name: 'admin.shared_link.edit', params:{linkID: link.id}}"
             color="primary">
        Edit link
      </v-btn>
      <v-btn v-if="1===2 && link.presentation_id"
             :href="`/admin/presentations/${link.presentation_id}/insights`"
             target="_blank">
        <v-icon left
                small>
          fal fa-fw fa-lightbulb
        </v-icon>
        Insights
      </v-btn>
      <v-btn v-if="1===2 && link.presentation_id"
             :href="`/admin/presentations/${link.presentation_id}/shared-links`"
             target="_blank">
        <v-icon left
                small>
          fal fa-fw fa-chart-line
        </v-icon>
        Dashboard
      </v-btn>
      <v-btn v-if="(link.type_space && link.space.is_active) || (link.presentation_id && link.presentation && link.presentation.is_active)"
             @click.prevent="showQRCodeDialog = true">
        <v-icon left
                small>
          fal fa-fw fa-qrcode
        </v-icon>
        Show QR Code
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn v-if="1===2 && link.is_expired === false"
             outlined>
        <v-icon left
                small>
          fal fa-fw fa-clock
        </v-icon>
        Expire this link
      </v-btn>
    </v-card-actions>

    <SharedLinkQrCodeDialog v-if="showQRCodeDialog"
                            :dialog="showQRCodeDialog"
                            :link="link"
                            @closed="showQRCodeDialog = false">
    </SharedLinkQrCodeDialog>
  </v-card>
</template>
<script>
import SharedLinkField from './SharedLinkField.vue';
import {mapGetters} from 'vuex';
import SharedLinkQrCodeDialog from './SharedLinkQrCodeDialog.vue';

export default {
  components: {SharedLinkQrCodeDialog, SharedLinkField},
  props: {
    link: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      showMore: false,
      showQRCodeDialog: false,
    }
  },
  computed: {
    ...mapGetters([
      'canEditPresentations',
      'canUserCreateSpaces',
    ]),
    presentation() {
      return this.link.presentation;
    },
    url() {
      if (this.link.alias_url) {
        return this.link.alias_url;
      }
      return this.link.share_url;
    },
  },
  methods: {
    addParameters(url) {
      //return `${url}?email={{email}}&sender={{user_email}}`;
      return `${url}?r={{jwt}}`; // MLD-6403
    }
  }
}
</script>
